const letterSpacing = {
  name: "letter-spacing",
  path: "/letter-spacing",
  title: "letter-spacing",
  description: "Utilities for controlling the letter spacing of text.",
  value: {
    "letter-spacing": {
      "tracking-tighter": "-0.05em",
      "tracking-tight": "-0.025em",
      "tracking-normal": "0em",
      "tracking-wide": "0.025em",
      "tracking-wider": "0.05em",
      "tracking-widest": "0.1em",
      "tracking-[<value>]": "<value>",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="tracking-tighter text-lg">The quick brown fox jumps over the lazy dog. (tighter)</p>
<p class="tracking-tight text-lg">The quick brown fox jumps over the lazy dog. (tight)</p>
<p class="tracking-normal text-lg">The quick brown fox jumps over the lazy dog. (normal)</p>
<p class="tracking-wide text-lg">The quick brown fox jumps over the lazy dog. (wide)</p>
<p class="tracking-wider text-lg">The quick brown fox jumps over the lazy dog. (wider)</p>
<p class="tracking-widest text-lg">The quick brown fox jumps over the lazy dog. (widest)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">tracking-tighter</code> through <code class="text-color-gray-800 dark:text-color-white font-semibold">tracking-widest</code> to control letter spacing:
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-tighter</small>
          <p class="tracking-tighter text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-tight</small>
          <p class="tracking-tight text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-normal</small>
          <p class="tracking-normal text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-wide</small>
          <p class="tracking-wide text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-wider</small>
          <p class="tracking-wider text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-widest</small>
          <p class="tracking-widest text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
}
export default letterSpacing;

<div class="sr-only">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-tighter</small>
          <p class="tracking-tighter text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-tight</small>
          <p class="tracking-tight text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-normal</small>
          <p class="tracking-normal text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-wide</small>
          <p class="tracking-wide text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-wider</small>
          <p class="tracking-wider text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">tracking-widest</small>
          <p class="tracking-widest text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>